import { useI18n } from "../../lib/i18n";
import { Zap, TrendingUp, Waves, Landmark } from "lucide-react";

export const TRADING_STYLES = [
  { key: "SCALPING", Icon: Zap, labelKey: "style_scalping", tfKey: "style_scalping_tf" },
  { key: "DAY_TRADING", Icon: TrendingUp, labelKey: "style_day", tfKey: "style_day_tf" },
  { key: "SWING", Icon: Waves, labelKey: "style_swing", tfKey: "style_swing_tf" },
  { key: "LONG_TERM", Icon: Landmark, labelKey: "style_long", tfKey: "style_long_tf" },
];

export const TradingStyleSelector = ({ value, onChange }) => {
  const { t } = useI18n();
  return (
    <div data-testid="trading-style-selector">
      <span className="label-mono">{t("style_label")}</span>
      <div className="mt-3 grid grid-cols-2 lg:grid-cols-4 gap-2">
        {TRADING_STYLES.map(({ key, Icon, labelKey, tfKey }) => {
          const active = value === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              className={`group text-left p-3 border transition-all ${
                active
                  ? "border-bull bg-bull/[0.06] shadow-[inset_0_0_0_1px_rgba(16,185,129,0.3)]"
                  : "border-white/10 bg-white/[0.02] hover:border-white/25"
              }`}
              data-testid={`style-${key.toLowerCase()}-btn`}
            >
              <div className="flex items-center justify-between">
                <Icon className={`h-4 w-4 ${active ? "text-bull" : "text-neutral-500 group-hover:text-neutral-300"}`} strokeWidth={1.5} />
                {active && <span className="h-1.5 w-1.5 rounded-full bg-bull animate-pulse-glow" />}
              </div>
              <div className={`mt-2 text-sm font-medium ${active ? "text-white" : "text-neutral-300"}`}>{t(labelKey)}</div>
              <div className="mt-0.5 font-mono text-[10px] tracking-wider text-neutral-500">{t(tfKey)}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
